<template>
  <div>
    <my-notification :icon="'info'">
      <template #title>
        {{ $t('compCarbonDocsMethodology.title-pres') }}
      </template>
      <p>
        {{ $t('compCarbonDocsMethodology.pres-1-1') }}
        <br />
        {{ $t('compCarbonDocsMethodology.pres-1-2') }}
      </p>
    </my-notification>
    <br />
    <b-tabs>
      <b-tab-item
        icon="check"
        :label="$t('compCarbonDocsMethodology.title-generic-short')"
      >
        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-generic-1') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.generic-1-1') }}
          <em>
            <a
              target="_blank"
              class="link"
              href="https://www.ecologie.gouv.fr/sites/default/files/methodo_BEGES_decli_07.pdf"
            >
              {{ $t('compCarbonDocsMethodology.generic-1-em') }}
            </a>
          </em>
          {{ $t('compCarbonDocsMethodology.generic-1-2') }}<br />
          {{ $t('compCarbonDocsMethodology.generic-1-3') }}<br />
          {{ $t('compCarbonDocsMethodology.generic-1-4')
          }}<em>{{ $t('compCarbonDocsMethodology.g1p5') }}</em
          >{{ $t('compCarbonDocsMethodology.generic-1-5') }}<br />
          {{ $t('compCarbonDocsMethodology.generic-1-6') }}
          <ul style="list-style-type: square; margin-left: 25px">
            <li>{{ $t('compCarbonDocsMethodology.generic-1-li') }}</li>
            <li>{{ $t('compCarbonDocsMethodology.generic-1-li-2') }}</li>
            <li>{{ $t('compCarbonDocsMethodology.generic-1-li-3') }}</li>
            <li>{{ $t('compCarbonDocsMethodology.generic-1-li-4') }}</li>
            <li>{{ $t('compCarbonDocsMethodology.generic-1-li-5') }}</li>
          </ul>
          {{ $t('compCarbonDocsMethodology.generic-1-7') }}
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-generic-3') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.generic-3') }}
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-generic-4') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.generic-4-1')
          }}<b>{{ $t('compCarbonDocsMethodology.generic-4-b') }}</b
          >{{ $t('compCarbonDocsMethodology.generic-4-2') }}
          <ol style="margin-left: 25px">
            <li>{{ $t('compCarbonDocsMethodology.generic-4-li-1') }}</li>
            <li v-html="$t('compCarbonDocsMethodology.generic-4-li-2')" />
            <li>{{ $t('compCarbonDocsMethodology.generic-4-li-3') }}</li>
            <li>{{ $t('compCarbonDocsMethodology.generic-4-li-4') }}</li>
          </ol>
          {{ $t('compCarbonDocsMethodology.generic-4-3') }}
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-generic-5') }}</b
          ><br />
          <span v-html="$t('compCarbonDocsMethodology.generic-5')" />
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-generic-6') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.generic-6') }}
        </b-notification>
      </b-tab-item>
      <b-tab-item
        icon="check"
        :label="$t('compCarbonDocsMethodology.title-methodo-short')"
      >
        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-methodo-1') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.methodo-1-1') }}<br />
          {{ $t('compCarbonDocsMethodology.methodo-1-2') }}<br />
          {{ $t('compCarbonDocsMethodology.methodo-1-3') }}
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-methodo-2') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.methodo-2') }}
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-methodo-3') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.methodo-3-1') }}<br />
          {{ $t('compCarbonDocsMethodology.methodo-3-2') }}<br />
          {{ $t('compCarbonDocsMethodology.methodo-3-3') }}
          <ul style="list-style-type: square; margin-left: 25px">
            <li>{{ $t('compCarbonDocsMethodology.methodo-3-li-1') }}</li>
            <li>{{ $t('compCarbonDocsMethodology.methodo-3-li-2') }}</li>
            <li>{{ $t('compCarbonDocsMethodology.methodo-3-li-3') }}</li>
            <li>{{ $t('compCarbonDocsMethodology.methodo-3-li-4') }}</li>
          </ul>
          {{ $t('compCarbonDocsMethodology.methodo-3-4') }}
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-methodo-6') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.methodo-6-1')
          }}<em>{{ $t('compCarbonDocsMethodology.g1p5') }}</em
          >{{ $t('compCarbonDocsMethodology.methodo-6-2') }}<br />
          {{ $t('compCarbonDocsMethodology.methodo-6-3') }}
          <ul style="list-style-type: square; margin-left: 25px">
            <li>{{ $t('compCarbonDocsMethodology.methodo-6-li-1') }}</li>
            <li>{{ $t('compCarbonDocsMethodology.methodo-6-li-2') }}</li>
          </ul>
          {{ $t('compCarbonDocsMethodology.methodo-6-4') }}
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-methodo-4') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.methodo-4-1')
          }}<em>{{ $t('compCarbonDocsMethodology.g1p5') }}</em
          >{{ $t('compCarbonDocsMethodology.methodo-4-2') }}<br />
          {{ $t('compCarbonDocsMethodology.methodo-4-3') }}
        </b-notification>

        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-methodo-5') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.methodo-5-1')
          }}<em>{{ $t('compCarbonDocsMethodology.g1p5') }}</em
          >{{ $t('compCarbonDocsMethodology.methodo-5-2') }}
        </b-notification>
      </b-tab-item>
      <b-tab-item
        icon="cog"
        :label="$t('compCarbonDocsMethodology.title-results')"
      >
        <b-notification :closable="false">
          <b>{{ $t('compCarbonDocsMethodology.subtit-results-1') }}</b
          ><br />
          {{ $t('compCarbonDocsMethodology.results-1-1') }}<br />
          {{ $t('compCarbonDocsMethodology.results-1-2') }}
        </b-notification>
        <b-tabs>
          <b-tab-item
            icon="bank"
            :label="$t('compCarbonDocsMethodology.subtit-results-2')"
          >
            <b-notification :closable="false">
              {{ $t('compCarbonDocsMethodology.results-2-1') }}
              <b-tooltip
                multilined
                :label="$t('compCarbonDocsMethodology.results-2-tip')"
                type="is-black"
              >
                <b-icon icon="info-circle" />
              </b-tooltip>
              {{ $t('compCarbonDocsMethodology.results-2-2')
              }}<em>
                <a
                  target="_blank"
                  class="link"
                  href="https://www.ecologie.gouv.fr/sites/default/files/methodo_BEGES_decli_07.pdf"
                >
                  {{ $t('compCarbonDocsMethodology.results-2-em') }}
                </a> </em
              >{{ $t('compCarbonDocsMethodology.results-2-3') }}
              <ul style="list-style-type: square; margin-left: 25px">
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-cat1') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-cat2') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-cat3') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-cat4') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-cat5') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-cat6') }}</li>
              </ul>
              {{ $t('compCarbonDocsMethodology.results-2-4') }}<br />
              {{ $t('compCarbonDocsMethodology.results-2-5') }}
              <ul style="list-style-type: square; margin-left: 25px">
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-4') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-5') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-6') }}</li>
              </ul>
              {{ $t('compCarbonDocsMethodology.results-2-6') }}
              <ul style="list-style-type: square; margin-left: 25px">
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-7') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-8') }}</li>
              </ul>
              {{ $t('compCarbonDocsMethodology.results-2-7') }}
              <ul style="list-style-type: square; margin-left: 25px">
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-15') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-11') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-10') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-18') }}</li>
              </ul>
              {{ $t('compCarbonDocsMethodology.results-2-7-cat4') }}
              <ul style="list-style-type: square; margin-left: 25px">
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-9') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-13') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-12') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-14') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-16') }}</li>
              </ul>
              {{ $t('compCarbonDocsMethodology.results-2-7-cat5') }}
              <ul style="list-style-type: square; margin-left: 25px">
                <li>{{ $t('compCarbonDocsMethodology.results-2-li-17') }}</li>
              </ul>
              {{ $t('compCarbonDocsMethodology.results-2-8') }}<br /><br />
              {{ $t('compCarbonDocsMethodology.results-2-9') }}<br />
              {{ $t('compCarbonDocsMethodology.results-2-10') }}<br />
              {{ $t('compCarbonDocsMethodology.results-2-11') }}<br />
              {{ $t('compCarbonDocsMethodology.results-2-12') }}<br />
              {{ $t('compCarbonDocsMethodology.results-2-13') }}
            </b-notification>
          </b-tab-item>

          <b-tab-item icon="dot-circle-o" :label="$t('ghg-protocol')">
            <b-notification :closable="false">
              {{ $t('compCarbonDocsMethodology.ghg-summary-1') }}
              <a target="_blank" class="link" href="https://ghgprotocol.org">
                (Green House Gas Protocol)
              </a>
              {{ $t('compCarbonDocsMethodology.ghg-summary-1b') }}<br />
              {{ $t('compCarbonDocsMethodology.ghg-summary-2') }}
              <ul style="list-style-type: square; margin-left: 25px">
                <li>
                  {{ $t('compCarbonDocsMethodology.ghg-summary-scope1') }}
                </li>
                <li>
                  {{ $t('compCarbonDocsMethodology.ghg-summary-scope2') }}
                </li>
                <li>
                  {{ $t('compCarbonDocsMethodology.ghg-summary-scope3') }}
                </li>
              </ul>
              {{ $t('compCarbonDocsMethodology.ghg-cat') }}
              <ul style="list-style-type: square; margin-left: 25px">
                <li>{{ $t('compCarbonDocsMethodology.ghg-scope3.cat1') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.ghg-scope3.cat2') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.ghg-scope3.cat3') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.ghg-scope3.cat4') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.ghg-scope3.cat5') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.ghg-scope3.cat6') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.ghg-scope3.cat7') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.ghg-scope3.cat8') }}</li>
                <li>{{ $t('compCarbonDocsMethodology.ghg-scope3.cat15') }}</li>
              </ul>
              {{ $t('compCarbonDocsMethodology.ghg-notes.upstream')
              }}<br /><br />
              {{ $t('compCarbonDocsMethodology.ghg-notes.boats-1') }}<br />
              {{ $t('compCarbonDocsMethodology.ghg-notes.boats-2') }}<br />
              {{ $t('compCarbonDocsMethodology.ghg-notes.boats-3') }}<br />
              {{ $t('compCarbonDocsMethodology.ghg-notes.boats-4') }}<br />
              {{ $t('compCarbonDocsMethodology.ghg-notes.boats-5') }}
            </b-notification>
          </b-tab-item>

          <b-tab-item
            icon="paw"
            :label="$t('compCarbonDocsMethodology.subtit-results-3')"
          >
            <b-notification :closable="false">
              {{ $t('compCarbonDocsMethodology.results-3-1') }}<br />
              {{ $t('compCarbonDocsMethodology.results-3-2') }}
            </b-notification>

            <b-notification :closable="false">
              <b
                ><em>{{
                  $t('compCarbonDocsMethodology.subtit-results-4')
                }}</em></b
              ><br />
              {{ $t('compCarbonDocsMethodology.results-4') }}<br />
              <pre>{{ $t('compCarbonDocsMethodology.results-4-pre-1') }}<br />
{{ $t('compCarbonDocsMethodology.results-4-pre-2') }}<br />
{{ $t('compCarbonDocsMethodology.results-4-pre-3') }}<br />
{{ $t('compCarbonDocsMethodology.results-4-pre-4') }}</pre>
            </b-notification>

            <b-notification :closable="false">
              <b
                ><em>{{
                  $t('compCarbonDocsMethodology.subtit-results-7')
                }}</em></b
              ><br />
              <span v-html="$t('compCarbonDocsMethodology.results-7')" />
              <br /><br />
              <b
                ><em>{{
                  $t('compCarbonDocsMethodology.subtit-results-8')
                }}</em></b
              ><br />
              <span v-html="$t('compCarbonDocsMethodology.results-8')" />
            </b-notification>

            <b-notification :closable="false">
              <b
                ><em>{{
                  $t('compCarbonDocsMethodology.subtit-results-6')
                }}</em></b
              ><br />
              <span v-html="$t('compCarbonDocsMethodology.results-6')" /><br />
              <pre>{{ $t('compCarbonDocsMethodology.results-6-pre-1') }}</pre>
            </b-notification>

            <b-notification :closable="false">
              <b
                ><em>{{
                  $t('compCarbonDocsMethodology.subtit-results-5')
                }}</em></b
              ><br />
              <pre>{{ $t('compCarbonDocsMethodology.results-5-pre-1') }}<br/>
{{ $t('compCarbonDocsMethodology.results-5-pre-2') }}<br />
{{ $t('compCarbonDocsMethodology.results-5-pre-3') }}<br />
{{ $t('compCarbonDocsMethodology.results-5-pre-4') }}<br />
{{ $t('compCarbonDocsMethodology.results-5-pre-5') }}</pre>
            </b-notification>
          </b-tab-item>
        </b-tabs>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: 'Methodology',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>
